import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface ResetPasswordRequest extends Partial<AxiosRequestConfig> {
  params: {
    email: string
    returnUrl?: string | null
  }
}
interface ResetPasswordResponseData extends ResponseData {
  message: string
  status: number
  paymentReturnUrl?: string | null
}
export interface ResetPasswordResponse extends AxiosResponse {
  data: ResetPasswordResponseData
}

export function resetPasswordApi(
  { params }: ResetPasswordRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: "/auth/password/reset",
  }) as Promise<ResetPasswordResponse>
}

export interface VerifyResetPasswordLinkRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    token: string
  }
}

export interface VerifyResetPasswordLinkResponse extends AxiosResponse {
  data: ResetPasswordResponseData
}

export function verifyResetPasswordLinkApi(
  { params }: VerifyResetPasswordLinkRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "post",
    url: "/auth/verify/reset-link",
    headers: {
      authorization: `Bearer ${params.token}`,
    },
  }) as Promise<VerifyResetPasswordLinkResponse>
}

export interface SetNewPasswordRequest extends Partial<AxiosRequestConfig> {
  params: {
    password: string
    token: string
  }
}

export interface SetNewPasswordResponse extends AxiosResponse {
  data: ResetPasswordResponseData
}

export function setNewPasswordApi(
  { params }: SetNewPasswordRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: { ...params, avoidClientSideAuth: true },
    method: "post",
    url: "/auth/password/change",
    headers: {
      authorization: `Bearer ${params.token}`,
    },
  }) as Promise<SetNewPasswordResponse>
}
